import type { getNewsData } from '../getNewsData/getNewsData';
import { CustomCharts } from '#lib/websites/news/constants/custom-charts.js';

export const sortCharts = (
	charts: Awaited<ReturnType<typeof getNewsData>>['charts'],
	showExclusive: boolean,
	newsletterIndex: number,
	showLatestPodcasts: boolean
) => {
	const sortedCharts = [
		...charts.slice(0, 2),
		// Latest Podcasts takes the slot Exclusives used to hold, and Exclusives
		// moves two positions further down the rendered column — one data chart
		// ends up between them. Without the widget the original order stands.
		...(showLatestPodcasts ? [{ id: CustomCharts.LatestPodcasts }] : []),
		...charts.slice(2, 3),
		...(showExclusive ? [{ id: CustomCharts.HeniNewsExclusive }] : []),
		...charts.slice(3),
		...(newsletterIndex === -1 ? [{ id: CustomCharts.Newsletter }] : []),
	];

	if (newsletterIndex !== -1) {
		return [
			...sortedCharts.slice(0, newsletterIndex),
			{ id: CustomCharts.Newsletter },
			...sortedCharts.slice(newsletterIndex),
		];
	}

	return sortedCharts;
};
